"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const localized_strings_1 = __importDefault(require("localized-strings"));
const locales = new localized_strings_1.default({
    en: {
        expirationDate: '**Quote valid until:** {expirationDate}',
        fiscalId: '**Quote number {fiscalId}**',
        startAt: '**Issued on**:',
    },
    fr: {
        expirationDate: '**Date limite de validité\xa0:** {expirationDate}',
        fiscalId: '**Devis N° {fiscalId}**',
        startAt: '**Date d’émission**\xa0:',
    },
});
exports.default = locales;
